export const AVAILABLE_LOCALES = [
  { value: 'sl', label: 'Slovenščina' },
  { value: 'en', label: 'English' },
];
